import React from 'react'
import Link from 'next/link'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { isSoldOut } from 'lib/utils/product'
import styles from './styles.scss'

export const SoldOutRecovery = ({
  product,
  selectedOption,
  country,
  language,
  t,
}) => {
  // Resolve against current attributes so a previous product/stock response cannot
  // expose an alternative for an available (or no longer selected) variant.
  const option =
    selectedOption &&
    product.attributes?.find(
      ({ id_product_attribute }) =>
        id_product_attribute === selectedOption.id_product_attribute,
    )
  const { id_category: categoryId, link_rewrite: slug } = product.category || {}
  if (
    !option ||
    !isSoldOut(option) ||
    product.is_coming_soon ||
    !Number.isInteger(categoryId) ||
    categoryId < 1 ||
    typeof slug !== 'string' ||
    !/^[\p{L}\p{N}_-]+$/u.test(slug) ||
    !/^[a-z]{2}$/.test(country) ||
    !/^[a-z]{2}$/.test(language)
  )
    return null

  return (
    <div className="sold-out-recovery" data-cy="pdp-sold-out-recovery">
      <style jsx>{styles}</style>
      <Link
        href={`/category?id=${categoryId}`}
        as={`/${country}/${language}/clothes/${encodeURIComponent(slug)}`}
      >
        <a>
          {hasLocizeTranslation(
            t,
            'PDP_BROWSE_SIMILAR_STYLES',
            language === 'th'
              ? 'เลือกดูสไตล์ที่คล้ายกัน'
              : 'Browse similar styles',
          )}{' '}
          <span aria-hidden="true">→</span>
        </a>
      </Link>
    </div>
  )
}

SoldOutRecovery.defaultProps = {
  selectedOption: null,
  country: '',
  language: '',
}
SoldOutRecovery.propTypes = {
  product: PropTypes.shape({
    attributes: PropTypes.arrayOf(
      PropTypes.shape({ id_product_attribute: PropTypes.number }),
    ),
    is_coming_soon: PropTypes.bool,
    category: PropTypes.shape({
      id_category: PropTypes.number,
      link_rewrite: PropTypes.string,
    }),
  }).isRequired,
  selectedOption: PropTypes.shape({ id_product_attribute: PropTypes.number }),
  country: PropTypes.string,
  language: PropTypes.string,
  t: PropTypes.func.isRequired,
}

export default connect(({ internationalization }) => ({
  country: internationalization.country,
  language: internationalization.language,
}))(withI18next()(SoldOutRecovery))
